import axios from "axios";

export const getUserDeActivate = async (id:number) => {
    return await axios({
		url: `/User/DeActivate?id=${id}`,
		method: "GET",
	});
}